import * as React from 'react';
import {connect} from "react-redux";
import {Payment, PaymentDescriptor} from "../../models/Payment";
import {ApplicationState} from "../../store";
import {PaymentList} from '../components/PaymentList';
import {ColumnData} from '../../models/ColumnData';
import {AppStore} from "../../desktop";
import {PaymentsActionTypes} from "../../store/payments";
import {Button} from "@material-ui/core";
import {Tab, TabTypes} from "../Tab";
import {TabsService} from "../TabsService";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {actionPaymentDelete, actionDeletePayments} from '../../store/payments/actions';
import {Customer} from '../../models/Customer';
import {actionCustomerFetchAll} from '../../store/customers/actions';
import {t} from "../../core/localization";

export interface PaymentsTabProps {
	payments: Payment[]
	tab: Tab
	customers: Customer[]
}

export interface PaymentsTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		payments: state.payments.list,
		tab: state.tabs.active,
		customers: state.customers.list
	};
}

class PaymentsTab extends React.Component<PaymentsTabProps, PaymentsTabState> {

	constructor(props: PaymentsTabProps) {
		super(props)
	}

	componentDidMount() {
		this.loadData()
	}

	onOpenClick(payment: Payment){
		TabsService.createTab(t.Payment + ' ' + payment.description, TabTypes.PAYMENTS_NEW, payment)
	}

	onCopyClick(payment: Payment){
		TabsService.createTab(t.Payment + ' ' + payment.description, TabTypes.PAYMENTS_NEW, { ...payment, id: null })
	}

	onDeleteClick(payment: Payment){
		actionPaymentDelete(payment);
	}

	onActionDeleteClick(payments: Payment[]){
		actionDeletePayments(payments);
	}

	onNewClick() {
		TabsService.createTab(t.NewPayment, TabTypes.PAYMENTS_NEW, new Payment())
	}

	render(): React.ReactNode {

		const {payments, customers} = this.props;

		let customersMap = customers.reduce(function(map: any, obj: any) {
			map[obj.id] = obj.title;
			return map;
			}, {});

		const columns = [
			new ColumnData(t.Customer, "customerId", customersMap),
			new ColumnData(t.Date, "paymentDate"),
			new ColumnData(t.PriceAmount, "price"),
		];

		return (
			<div style={{padding: '10px'}}>

				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}>
					<AddIcon />{t.CreateNewPayment}</Button>
				</div>

				<PaymentList
					columns={columns}
					items={payments}
					title={t.Payments}
					onOpenClick={(payment: Payment) => this.onOpenClick(payment)}
					onCopyClick={(payment: Payment) => this.onCopyClick(payment)}
					onDeleteClick={(payment: Payment) => this.onDeleteClick(payment)}
					onActionDeleteClick={(payments: Payment[]) => this.onActionDeleteClick(payments)}
					tab={this.props.tab}
					descriptor={PaymentDescriptor}
				/>
			</div>
		);
	}

	private loadData() {
		actionCustomerFetchAll()
		AppStore.dispatch({type: PaymentsActionTypes.FETCH_ALL_REQUEST})
	}
}

export default connect(mapStateToProps)(PaymentsTab);
